import {defaultBoardLabels} from '@github-ui/board'
import {useLocation} from '@github-ui/react-router'
import {Suspense, useMemo} from 'react'

import {readBoardParams} from '../../utils/board-url-params'
import {BoardSurface} from './generic/BoardSurface'
import {BoardCard} from './issues/BoardCard'
import {useBoardSource} from './use-board-source'

export function SavedViewBoard({owner, repo, query}: {owner: string; repo: string; query: string}) {
  return (
    <Suspense fallback={null}>
      <SavedViewBoardContent owner={owner} repo={repo} query={query} />
    </Suspense>
  )
}

function SavedViewBoardContent({owner, repo, query}: {owner: string; repo: string; query: string}) {
  const {search} = useLocation()
  const params = useMemo(() => readBoardParams(new URLSearchParams(search)), [search])
  const source = useBoardSource({owner, repo, query, params})

  return <BoardSurface source={source} renderCard={item => <BoardCard item={item} />} labels={defaultBoardLabels} />
}
